
// AOS Animations JS Start Here

AOS.init({
    once: true,
});
AOS.refresh();

// AOS Animations JS End here


progressJs().setOptions({
    overlayMode: true,
    theme: 'blueOverlay'
  }).start().autoIncrease(4, 500);
  
  if (window.attachEvent) {
    window.attachEvent('onload', function () {
      progressJs().end();
    });
  } else {
    if (window.onload) {
      var curronload = window.onload;
  
      var newonload = function newonload() {
        curronload();
        progressJs().end();
      };
  
      window.onload = newonload;
    } else {
      window.onload = function () {
        progressJs().end();
      };
    }
  }
  
$(window).on('load', function () {
    $('.loader').fadeOut();
}); 


//Overlay Navbar Start

$(document).ready(function(){
    $(".menu-icon-otr").click(function(){
        $(".overlay-content").addClass("overlay-open");
        $("body").addClass("overflow");
    });
    $(".close-icon-otr").click(function(){
        $(".overlay-content").removeClass("overlay-open");
        $("body").removeClass("overflow");
    });
});

//Overlay Navbar Start

//Overlay Navbar Start

$(document).ready(function(){
    $(".drop-eng").click(function(){
        $(".dropdown-eng").toggleClass("eng-open");
    });
});

//Overlay Navbar Start


const swiper = new Swiper('#swiper1', {
    spaceBetween: 24,
    loop: true,
    slidesPerView: 2,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
    },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 2,
        },
        1300: {
            slidesPerView: 2,
        }
    }
});

const swiper2 = new Swiper('#swiper2', {
    spaceBetween: 24,
    loop: false,
    effect: "fade",
    speed: 2000,
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 1,
        },
        992: {
            slidesPerView: 1,
        },
        1300: {
            slidesPerView: 1,
        }
    }
});

const swiper3 = new Swiper('#swiper3', {
    spaceBetween: 24,
    loop: false,
    effect: "fade",
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 1,
        },
        992: {
            slidesPerView: 1,
        },
        1300: {
            slidesPerView: 1,
        }
    }
});

const swiper4 = new Swiper('#swiper4', {
    spaceBetween: 24,
    loop: true,
    slidesPerView: 2,
    centeredSlides: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        575: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 2,
        },
        1300: {
            slidesPerView: 2,
        }
    }
});

const swiper5 = new Swiper('#swiper5', {
    spaceBetween: 24,
    loop: true,
    slidesPerView: 2,
    centeredSlides: false,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        575: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 2,
        },
        1300: {
            slidesPerView: 2,
        }
    }
});




let SwiperTop = new Swiper('.swiper--top', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 10000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false,
    disableOnInteraction: true
});
  
  

